var map = {
	"./Logo-sinfin-spread_spreadsuite-retail edition.svg": 1678,
	"./Logo-spread-suite_HUB.svg": 1679,
	"./assets/Shopify.png": 1680,
	"./assets/advent-calendar-logo.png": 1681,
	"./assets/borne_kiosk.png": 1682,
	"./assets/cloudcommerce.png": 1683,
	"./assets/cms.png": 1684,
	"./assets/facebook.png": 1685,
	"./assets/flipbook-pagetype-home.svg": 1686,
	"./assets/game-pagetype-alreadyplayed_game.svg": 1687,
	"./assets/game-pagetype-ended_game.svg": 1688,
	"./assets/game-pagetype-game_game.svg": 1689,
	"./assets/game-pagetype-home_game.svg": 1690,
	"./assets/game-pagetype-index_game.svg": 1691,
	"./assets/game-pagetype-login_game.svg": 1692,
	"./assets/game-pagetype-not_started_game.svg": 1693,
	"./assets/game-pagetype-results_loose_game.svg": 1694,
	"./assets/game-pagetype-results_win_game.svg": 1695,
	"./assets/gift_finder.png": 1696,
	"./assets/instagram.png": 1697,
	"./assets/instant-logo.png": 1698,
	"./assets/instore.png": 1699,
	"./assets/ipad_kiosk.png": 1700,
	"./assets/jeu.png": 1701,
	"./assets/magento.png": 1702,
	"./assets/marker.png": 1703,
	"./assets/minisite-pagetype-contact.svg": 1704,
	"./assets/minisite-pagetype-email_register.svg": 1705,
	"./assets/minisite-pagetype-flipbook.svg": 1706,
	"./assets/minisite-pagetype-home.svg": 1707,
	"./assets/minisite-pagetype-landing.svg": 1708,
	"./assets/minisite-pagetype-product_details.svg": 1709,
	"./assets/minisite-pagetype-register.svg": 1710,
	"./assets/minisite-pagetype-register_success.svg": 1711,
	"./assets/minisite-pagetype-wishlist.svg": 1712,
	"./assets/minisite.png": 1713,
	"./assets/online.png": 1714,
	"./assets/pinterest.png": 1715,
	"./assets/prestashop.png": 1716,
	"./assets/quizz-logo.png": 1717,
	"./assets/random-draw-logo.png": 1718,
	"./assets/rs.png": 1719,
	"./assets/store.png": 1720,
	"./assets/twitter.png": 1721,
	"./assets/woocommerce.png": 1722,
	"./assets/wordpress.png": 1723,
	"./avatar.png": 1724,
	"./banner.png": 1725,
	"./banner_video.png": 729,
	"./dashboard/dashboard_flux_de_travail.png": 440,
	"./dashboard/dashboard_prices.png": 730,
	"./ecran.png": 726,
	"./emptyCatalog.jpg": 279,
	"./emptyCompany.jpg": 216,
	"./image-fake-card.png": 67,
	"./image-fake.png": 319,
	"./image-home-dxp.png": 727,
	"./image-home-xl-test.png": 1726,
	"./image-home-xl.png": 728,
	"./john-doe.png": 229,
	"./lacoste.jpg": 1727,
	"./lacoste.svg": 1728,
	"./logo-sinfin-black.svg": 1729,
	"./logo-sinfin-digital.svg": 320,
	"./logo-sinfin-dxp.svg": 1730,
	"./logo-sinfin-new.svg": 1731,
	"./logo-spread-white.svg": 1732,
	"./logo-spread.svg": 1733,
	"./logo.png": 1734,
	"./logo_lego.svg": 1735,
	"./logo_sinfin.png": 1736,
	"./logotype-home.svg": 731,
	"./medias/Caisse.png": 732,
	"./medias/Citadium.png": 733,
	"./medias/Made-by-desgin.png": 734,
	"./medias/Nuxeo.png": 735,
	"./medias/Place-des-tendance.png": 736,
	"./medias/Printemps.png": 737,
	"./medias/admi-logo.png": 1737,
	"./medias/amazon-logo.png": 1738,
	"./medias/bestbuy-logo.png": 1739,
	"./medias/boulanger-logo.png": 1740,
	"./medias/brico_prive-logo.png": 1741,
	"./medias/brother-logo.png": 1742,
	"./medias/cdiscount-logo.png": 1743,
	"./medias/chronopost-logo.png": 1744,
	"./medias/cloudcommerce-logo.png": 1745,
	"./medias/colissimo-logo.png": 1746,
	"./medias/contentful-logo.png": 1747,
	"./medias/dropbox-logo.png": 1748,
	"./medias/drupal-logo.png": 1749,
	"./medias/ebay-logo.png": 1750,
	"./medias/facebook-logo.png": 1751,
	"./medias/farfetch-logo.png": 1752,
	"./medias/gdrive-logo.png": 1753,
	"./medias/google-shopping.png": 738,
	"./medias/googledrive-logo.png": 1754,
	"./medias/gshopping-logo.png": 1755,
	"./medias/instagram-logo.png": 1756,
	"./medias/laredoute-logo.png": 1757,
	"./medias/leboncoin-logo.png": 1758,
	"./medias/lengow-logo.png": 1759,
	"./medias/leroy_merlin-logo.png": 1760,
	"./medias/linkedin-logo.png": 1761,
	"./medias/magento-logo.png": 1762,
	"./medias/mailchimp-logo.png": 1763,
	"./medias/mailjet-logo.png": 1764,
	"./medias/manomano-logo.png": 1765,
	"./medias/mirakl-logo.png": 1766,
	"./medias/mondialrelay-logo.png": 1767,
	"./medias/onedrive-logo.png": 1768,
	"./medias/pinterest-logo.png": 1769,
	"./medias/pixelBackground.jpg": 426,
	"./medias/prestashop-logo.png": 1770,
	"./medias/rakuten-logo.png": 1771,
	"./medias/rdc-logo.png": 1772,
	"./medias/seloger-logo.png": 1773,
	"./medias/sendgrid-logo.png": 1774,
	"./medias/sendinblue-logo.png": 1775,
	"./medias/shopify-logo.png": 1776,
	"./medias/twitter-logo.png": 1777,
	"./medias/users/63d398aea0b42.png": 1778,
	"./medias/veepee-logo.png": 1779,
	"./medias/walmart-logo.png": 1780,
	"./medias/winrar.png": 1781,
	"./medias/woocommerce-logo.png": 1782,
	"./medias/wordpress-logo.png": 1783,
	"./medias/yoox-logo.png": 1784,
	"./medias/zalando-logo.png": 1785,
	"./minisite/Accueil.svg": 1786,
	"./minisite/Landing.svg": 1787,
	"./minisite/Produit.svg": 1788,
	"./minisite/Wishlist.svg": 1789,
	"./mirakl-logo-header.png": 1790,
	"./mirakl.png": 1791,
	"./not-found.png": 32,
	"./photo-home-notif.png": 1792,
	"./pictoVideo.svg": 515,
	"./retailers/Auchan.png": 194,
	"./retailers/Fcw.png": 1793,
	"./retailers/Lgr.png": 1794,
	"./sinfin-logo.svg": 718,
	"./socials/Calendar.png": 514,
	"./socials/Facebook.png": 1795,
	"./socials/Stats.png": 739,
	"./wiko-alpha.png": 1796,
	"./wiko.png": 1797
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 188;